import React from 'react';
import { useTranslation } from "react-i18next";

function KolsaiSightPage(props) 
{
    const { t } = useTranslation();

    return (
        <div className="uk-container uk-margin-large-top uk-margin-large-bottom">
            <h1 className="uk-heading-medium uk-margin-bottom">
                {t("kolsai.title", "Kolsai Lakes")}
            </h1>

            <p className="uk-text-lead uk-margin-bottom">
                {t(
                    "kolsai.intro",
                    "The Kolsai Lakes, often called the 'Pearls of the Northern Tien Shan', are a group of three mountain lakes located in southeastern Kazakhstan. Known for their emerald waters, alpine landscapes, and diverse flora and fauna, they are among the most scenic destinations in the country."
                )}
            </p>

            <h2 className="uk-heading-line uk-text-bold">
                <span>{t("kolsai.highlightsTitle", "Highlights")}</span>
            </h2>
            <ul className="uk-list uk-list-bullet uk-margin-bottom">
                <li>{t("kolsai.highlight1", "Three picturesque lakes at different altitudes, each with unique charm.")}</li>
                <li>{t("kolsai.highlight2", "Opportunities for hiking, horseback riding, and camping in pristine nature.")}</li>
                <li>{t("kolsai.highlight3", "Home to diverse wildlife, including marals, bears, and golden eagles.")}</li>
                <li>{t("kolsai.highlight4", "Proximity to Kaindy Lake, famous for its submerged forest.")}</li>
            </ul>

            <p className="uk-text uk-text-justify">
                {t(
                    "kolsai.conclusion",
                    "Kolsai Lakes National Park offers breathtaking alpine scenery and tranquility, making it a must-visit destination for those who appreciate unspoiled nature in Kazakhstan."
                )}
            </p>
        </div>
    );
}

export default KolsaiSightPage;
